import { Text } from '@treatwell/ui';
import React from 'react';
import clsx from 'clsx';
import styles from './ProTip.module.css';

type Props = { text: string | React.ReactElement };

export const ProTip = ({ text }: Props) => {
  return (
    <Text
      as="p"
      type="caption"
      className={clsx(styles.label, styles.eyesEmoji)}
    >
      {text}
    </Text>
  );
};
